"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateFacetSectionView = void 0;
var _react = _interopRequireDefault(require("react"));
var _FacetSectionView = _interopRequireDefault(require("../components/section/FacetSectionView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable import/prefer-default-export */
/* eslint-disable arrow-body-style */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable space-in-parens */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable eol-last */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable semi */

var generateFacetSectionView = function generateFacetSectionView(props) {
  return /*#__PURE__*/_react.default.createElement(_FacetSectionView.default, props);
};
exports.generateFacetSectionView = generateFacetSectionView;